import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { LEGISLATION_CATEGORIES } from 'constants/controllers'

export default new Controller({
  name: 'LegacyLegislationCategoriesRedirect',
  route: ':aol/legislation/folder',
  controller (Router, { query }) {
    const target = url(LEGISLATION_CATEGORIES, {}, query)
    replaceUrl(target)
  }
})
